import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function BranchSelectField({intl, settings, ...rest}) {

  const {state, name, subspecialism} = settings || {};
  const {onChange} = rest;
  const {
    additionalData: {branches},
    currentStep,
    setFormData
  } = useContext(FormContext);

  const BranchSpecialismField = () => {
    if (!branches || !Object.keys(branches).length) {
      return null;
    }
    const branchSpecialismOptions = [];
    if (branches && Object.keys(branches).length > 0) {
      branchSpecialismOptions.push({value: "", label: "-- please select --"});
      Object.keys(branches).forEach(key => branchSpecialismOptions.push({
        value: key,
        label: key
      }));
    }
    settings.options = branchSpecialismOptions;
    return (
      <SelectField
        settings={settings}
        {...rest}
        onChange={handleBranchSpecialismChange}
      />
    )
  };

  const handleBranchSpecialismChange = event => {
    if (settings && settings.subspecialism && settings.subspecialism.name) {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        const subSpecialismName = settings.subspecialism.name;
        prev[currentStep][subSpecialismName] = '';
        prev[currentStep]['specialism_id'] = '';
        prev[currentStep]['sub_specialism_id'] = '';
        return {
          ...prev
        }
      });
    }
    onChange(event);
  };

  const handleLocalBranchChange = event => {
    let value = event.target.value;
    if (settings && settings.subspecialism.subspecialism && settings.subspecialism.subspecialism.name) {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        const subSpecialismName = settings.subspecialism.subspecialism.name;
        const specialismName = settings.name;
        const values = settings.state;
        const selectedSpecialism = values[specialismName];
        if (!value ||
          !branches[selectedSpecialism] ||
          !branches[selectedSpecialism]['children'] ||
          !Object.keys(branches[selectedSpecialism]['children']).length ||
          !branches[selectedSpecialism]['children'][value] ||
          !branches[selectedSpecialism]['children'][value]['children'] ||
          !Object.keys(branches[selectedSpecialism]['children'][value]['children']).length
        ) {
          delete prev[currentStep][subSpecialismName];
        } else {
          prev[currentStep][subSpecialismName] = '';
        }
        prev[currentStep]['specialism_id'] = '';
        prev[currentStep]['sub_specialism_id'] = '';
        return {
          ...prev
        }
      });
    }
    onChange(event);
  }

  const LocalBranchField = () => {

    if (!branches || !Object.keys(branches).length) {
      return null;
    }

    let selectedBranch;
    if (state && state.hasOwnProperty(name) && state[name] && state[name].length) {
      selectedBranch = state[name];
    }
    const localBranchOptions = [];
    if (selectedBranch && branches[selectedBranch] && Object.keys(branches[selectedBranch].children).length > 0) {
      localBranchOptions.push({
        value: "",
        label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'})
      });
      Object.keys(branches[selectedBranch].children).forEach(key => localBranchOptions.push({
        value: key,
        label: key
      }));
    }

    if (!localBranchOptions.length) {
      return '';
    }
    settings.subspecialism.options = localBranchOptions;
    return (
      <SelectField
        settings={{...settings, ...settings.subspecialism}}
        {...rest}
        onChange={handleLocalBranchChange}
      />
    )
  }

  const BranchSubSpecialismField = () => {

    if (!branches || !Object.keys(branches).length) {
      return null;
    }
    let selectedBranch;
    if (state && state.hasOwnProperty(name) && state[name] && state[name].length) {
      selectedBranch = state[name];
    }
    let selectedLocalBranch
    if (state && state.hasOwnProperty(subspecialism.name) && state[subspecialism.name] && state[subspecialism.name].length) {
      selectedLocalBranch = state[subspecialism.name];
    }
    const subSpecialismOptions = [];
    if (
      selectedBranch &&
      selectedLocalBranch &&
      branches[selectedBranch] &&
      Object.keys(branches[selectedBranch].children).length > 0 &&
      branches[selectedBranch]['children'][selectedLocalBranch] &&
      Object.keys(branches[selectedBranch]['children'][selectedLocalBranch].children).length > 0
    ) {
      subSpecialismOptions.push({
        value: "",
        label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'})
      });
      Object.keys(branches[selectedBranch]['children'][selectedLocalBranch].children).forEach(key => subSpecialismOptions.push({
        value: key,
        label: key
      }));
    }
    if (!subSpecialismOptions.length) {
      return '';
    }
    settings.subspecialism.subspecialism.options = subSpecialismOptions;
    return (
      <SelectField
        settings={{...settings, ...settings.subspecialism.subspecialism}}
        {...rest}
      />
    )
  };

  return (
    <>
      <BranchSpecialismField/>
      <LocalBranchField/>
      <BranchSubSpecialismField/>
    </>
  )

}

export default injectIntl(BranchSelectField);
